import axios from 'axios'
import config from '../../public/config'

export default ({
  async getConfigs () {
    const res = await axios.get(`${config.apiurl}api/env`)

    if (res.status !== 200) {
      throw new Error(res.statusText)
    }
    return res.data
  }
})
